import React from 'react';

import { SeeAllPage } from 'shared/ui/layout';
import { AllRecommendations } from 'widgets/recommendations/ui/all-recommendations/all-recommendations';

const RecommendationsPage = () => {
  return (
    <SeeAllPage>
      <AllRecommendations />
    </SeeAllPage>
  );
};

export default RecommendationsPage;
